import { Component, Vue } from 'vue-property-decorator';
import { ScoutingReportScore, ScoutingReportScoreValues } from "@/../types/enums";
import { SelectorItem } from './selectorItem';

@Component
export class CoachReportScoreMixin extends Vue {
	get AvailableScoutingReportScoreValues(): SelectorItem<ScoutingReportScore>[] {
		return ScoutingReportScoreValues.map((value, i) => ({
			text: i === 4 ? '4+' :`${value}`,
			value: value,
		}));
	}
	get AvailableScoutingReportScores(): SelectorItem<number>[]{
		return [
			{text: '10', value:10},
			{text: '20', value:20},
			{text: '40', value:40},
			{text: '60', value:60},
			{text: '70', value:70},
			{text: '80', value:80},
			{text: '90', value:90},
			{text: '95', value:95},
		]
	}

	ScoreColor(value: string | number): string {
		if( Number(value) > 4.25 ) return 'purple darken-3';
		else if( Number(value) > 3.25 ) return 'green darken-4';
		else if( Number(value) > 2.75 ) return 'light-green darken-3';
		else if( Number(value) > 1.75 ) return 'lime darken-3';
		else if( Number(value) > 0.75 ) return 'deep-orange darken-4';
		else if( Number(value) > 0 ) return 'red darken-4';
		return 'grey'
	}
}